import { ProfileView } from "../views/profileView";
import { observer } from "mobx-react-lite";
import { NavBar } from "./navBarPresenter";
import { readFromFirebase } from "../firebaseModel.js";

const Profile = observer(
    function ProfileRender(props) {

        return (
            <div>
                <NavBar model={props.model}/>
                <ProfileView 
                id={props.model.userID} 
                history={props.model.quizHistory}
                setLoginHandler={setLoginHandler}/>
            </div>
        );

        function setLoginHandler(id){
            props.model.setUserID(id)
            readFromFirebase(props.model)
        }
    }
);

export { Profile };
